<template>
  <!-- 小さいサイズのクリエイターカード -->
  <v-card
    class="cCard text-center align-center"
    outlined
    :to="{
      name: 'creator-detail',
      params: {
        creatorKbn: item.creatorKbn,
        creatorId: item.creatorId,
      },
    }"
  >
    <div v-if="item.isOpen" class="cCard-Badge">
      受注中
    </div>
    <v-img
      height="120px"
      :src="
        item.coverIllust
          ? `${objectPath}/creator/cover/thumb/${item.coverIllust}.webP`
          : ''
      "
    >
      <template v-slot:placeholder>
        <v-img
          height="120px"
          :src="`${assetsPath}/p/img/default_cover.png`"
        ></v-img>
      </template>
    </v-img>

    <v-card-text>
      <BaseIcon
        :itemId="item.icon ? item.icon : ''"
        type="creator"
        size="100"
        contentClass="cCard-Avatar"
      />

      <div class="cCard-Title font-weight-bold fs-m">
        <CreatorKbnIcon class="fs-l pb-1" :creatorKbn="item.creatorKbn" />
        {{ item.creatorName }}
      </div>
      <FavBtn :key="item.creatorId" :creatorId="item.creatorId"></FavBtn>
      <div class="fs-s fc-gray-4" v-if="false">
        <v-icon x-small left>favorite</v-icon>
        <!-- TODO:お気に入り登録数ではなく、ふぇ〜（♥）の合計獲得数を表示する -->
        <span class="cr-Hero_Count">{{ item.feCnt }}</span>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import CreatorKbnIcon from "@/components/CreatorKbnIcon.vue";
import FavBtn from "@/components/FavBtn";
export default {
  name: "creatorCard",
  components: {
    CreatorKbnIcon,
    FavBtn,
  },
  props: {
    item: {
      mode: Object,
      required: true,
    },
  },

  data() {
    return {
      userId: "",
      shouhinKbn: "",
      creatorIdTemp: "",
      creatorName: "",
      dataLists: [],
      hyoukasuuCreatorTemp: "",
      jyuchuJyokyo: "0",
      listKbn: "",
      narabiGae: "",
      sakufun: "",
      followedDataLists: "",
      newCreatorDataLists: "",
      newUpDataLists: "",
      perPage: 4,
      perPage2: 4,
      perPage3: 4,
      page: 1,
      sampleLists: [],
      disableLike: [],

      col_creatorId: 0,
      col_creatorRank: 1,
      col_saishuNouhinDate: 2,
      col_hyoukasuuCreator: 3,
      col_sakufuKbn: 4,
      col_icon: 5,
      col_shinkiDateTime: 6,
      col_openWorldId: 7,
      col_juchuPoint: 8,
      col_yoyakuJuchuPoint: 9,
      col_juchuComment: 10,
      col_yoyakuJuchuComment: 11,
      col_homeText: 12,
      col_worldSitei: 13,
      col_sameSetupFlg: 14,
      col_yoyakuJuchubi: 15,
      col_creatorKbn: 16,
      col_creatorName: 17,
      col_sampleNaiyou1: 18,
      col_sampleNaiyou2: 19,
      col_sampleNaiyou3: 20,
      col_coverIllust: 21,
      col_feCnt: 22,
      col_point: 23,
    };
  },
  methods: {},
  async created() {},
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.cCard {
  position: relative;
  &-Avatar {
    box-sizing: content-box;
    margin-top: -75px;
    margin-bottom: 4px;
    background-color: var(--gray-2);
    border: solid 2px var(--white) !important;
  }
  &-Title {
    @include ellipsis;
  }
  &-Badge {
    position: absolute;
    top: 8px;
    left: 8px;
    z-index: $z-nav;
    padding: 1px 16px;
    font-size: $fs-xs;
    font-weight: bold;
    color: var(--white);
    background-color: var(--c-primary);
    border-radius: 0 !important;
  }
}
</style>
